module.exports = __webpack_public_path__ + "img/fullscreen.9456059a.svg";